import { InlineTagFormWebComponent } from './component/InlineTagFormWebComponent';
import { WEB_COMPONENT_INLINE_TAG_FORM } from '../../../webcomponents.constants';

export { InlineTagFormWebComponent };

window.customElements.define(WEB_COMPONENT_INLINE_TAG_FORM, InlineTagFormWebComponent);
